import MarketingPage from "./_shared/MarketingPage";
import { Swoosh } from "./_shared/Hero";

export default function LebensgeschichtePodcast() {
  return (
    <MarketingPage
      eyebrow="Format · Familien-Podcast"
      h1={
        <>
          Die Lebensgeschichte als privater Familien-<Swoosh>Podcast</Swoosh>
        </>
      }
      lead={
        <>
          Ein Podcast funktioniert anders als ein Hörbuch. Ein Hörbuch ist
          ein abgeschlossenes Werk, das man von Anfang bis Ende anhört. Ein
          Podcast ist ein Begleiter — Folge für Folge, eine Woche nach der
          anderen. Vitanara bietet beides. Der{" "}
          <strong>private Familien-Podcast</strong> verteilt die Geschichten
          der erzählenden Person in kuratierten Folgen an einen
          geschlossenen Hörerkreis.
        </>
      }
      sections={[
        {
          h2: "Was ein privater Familien-Podcast ist",
          body: (
            <p style={{ margin: 0 }}>
              Anders als öffentliche Podcasts auf Spotify oder Apple Podcasts
              ist der Vitanara-Podcast nur über einen{" "}
              <strong>persönlichen Feed-Link</strong> zugänglich, den Sie
              mit Familienmitgliedern teilen. Niemand sonst kann zuhören.
              Keine Werbung, keine Algorithmen, keine Reichweite.
            </p>
          ),
        },
        {
          h2: "Vorteile gegenüber dem Buch oder Hörbuch allein",
          body: (
            <>
              <p style={{ margin: "0 0 10px" }}>
                <strong>Verteilung über Zeit.</strong> Manche Familien
                wünschen sich keine fertige Bilanz, sondern ein Mitlaufen.
                Jede Woche kommt eine neue Folge — und das Gespräch in der
                Familie bekommt einen wiederkehrenden Anlass.
              </p>
              <p style={{ margin: "0 0 10px" }}>
                <strong>Längere Form.</strong> Manche Anekdoten passen nicht
                ins Buch, sind aber zu schön, um zu verschwinden. Im Podcast
                finden sie Platz.
              </p>
              <p style={{ margin: 0 }}>
                <strong>Gemeinsames Hören.</strong> Eine Folge im Auto, beim
                Kochen, beim Spazieren — auch über Zeitzonen hinweg, wenn
                Familienmitglieder im Ausland leben.
              </p>
            </>
          ),
        },
        {
          h2: "Wie der Podcast verteilt wird",
          body: (
            <p style={{ margin: 0 }}>
              Sie erhalten einen privaten RSS-Feed, den jedes Familienmitglied
              in seine bevorzugte Podcast-App (Apple Podcasts, Spotify,
              Pocket Casts, Overcast, weitere) einfügt. Der Feed ist
              passwortgeschützt. Folgen erscheinen typischerweise
              wöchentlich über ein halbes Jahr.
            </p>
          ),
        },
        {
          h2: "Was eine Folge typischerweise enthält",
          body: (
            <p style={{ margin: 0 }}>
              Eine Folge dauert zwischen zwanzig und fünfundvierzig Minuten
              und behandelt ein in sich geschlossenes Thema: ein
              Lebensabschnitt, ein Mensch, ein Ort, eine wiederkehrende
              Erinnerung. Anders als das Buch ist der Podcast nicht
              chronologisch — sondern thematisch sortiert. Beide Formen
              ergänzen sich.
            </p>
          ),
        },
      ]}
      faqs={[
        {
          q: "Wer hört den Podcast?",
          a: "Nur Familienmitglieder mit dem privaten Feed-Link. Sie entscheiden, wer ihn bekommt.",
        },
        {
          q: "Können Folgen nachträglich gelöscht werden?",
          a: "Ja. Falls die erzählende Person eine Passage zurückziehen möchte, wird die entsprechende Folge entfernt.",
        },
        {
          q: "Was passiert mit dem Podcast nach Abschluss?",
          a: "Der Feed bleibt dauerhaft erhalten, solange Sie ihn behalten möchten. Eine archivierte Audiokopie wird zusätzlich auf einem USB-Stick geliefert, falls die Cloud-Verteilung in Jahrzehnten nicht mehr existiert.",
        },
      ]}
      crossLinks={[
        {
          to: "/lebensgeschichte-als-hoerbuch",
          label: "Lebensgeschichte als Hörbuch",
          blurb:
            "Das abgeschlossene Werk in der Originalstimme — ergänzend zum Podcast.",
        },
        {
          to: "/wie-funktioniert-vitanara",
          label: "Wie funktioniert Vitanara?",
          blurb: "Vom Anruf bis zum fertigen Buch in zwölf Wochen.",
        },
        {
          to: "/preise",
          label: "Preise",
          blurb:
            "Was kostet eine Biografie? Während der Beta für ausgewählte Familien kostenlos.",
        },
      ]}
    />
  );
}
